import React, { Component } from 'react';
import './css/InstanceBanner.css';

// A slim coloured strip along the top of every page of the staging and dev
// copies, so nobody mistakes them for the live system. Live never shows it
// (its paths.json has no "environment" and its address isn't staging./dev.).
export const BANNER_HEIGHT = 22;

const LABEL = {
  staging: 'STAGING VERSION — test copy of the system, not live',
  dev: 'DEV VERSION — development copy of the system, not live',
};

// Most of the page is position:fixed with its top offset written in the
// stylesheets (menu, top bar, side panels, pop-ups ...). To make room for the
// banner, every such rule is moved down by --banner-h. This only runs on a
// staging/dev copy; live never gets here, so live's CSS is untouched.
var shifted = false;
function makeRoom() {
  if (shifted) { return; }
  shifted = true;
  var visit = function(rules) {
    Array.prototype.forEach.call(rules, function(rule) {
      if (rule.selectorText && rule.selectorText.indexOf('InstanceBanner') !== -1) { return; }
      if (rule.cssRules) { visit(rule.cssRules); }              // @media, @supports ...
      var style = rule.style;
      if (style && style.position === 'fixed') {
        var top = style.getPropertyValue('top');
        if (top && top !== 'auto') {
          style.setProperty('top', 'calc(' + top + ' + var(--banner-h, 0px))', style.getPropertyPriority('top'));
        }
      }
    });
  };
  Array.prototype.forEach.call(document.styleSheets, function(sheet) {
    try { visit(sheet.cssRules); } catch (e) { /* another site's stylesheet: not ours to change */ }
  });
}

class InstanceBanner extends Component {
  componentDidMount() { this.apply(); }
  componentDidUpdate() { this.apply(); }
  componentWillUnmount() { this.apply(true); }
  apply(off) {
    var on = !off && !!LABEL[this.props.env];
    if (on) { makeRoom(); }
    document.documentElement.style.setProperty('--banner-h', on ? BANNER_HEIGHT + 'px' : '0px');
    document.body.style.marginTop = on ? BANNER_HEIGHT + 'px' : '';
    if (this.props.root && typeof this.props.root.scale === 'function') { this.props.root.scale(); }
  }
  render() {
    var env = this.props.env;
    if (!LABEL[env]) { return null; }
    return (<div className={'InstanceBanner ' + env} id="InstanceBanner" role="note">{LABEL[env]}</div>);
  }
}

export default InstanceBanner;



// WEBPACK FOOTER //
// ./src/InstanceBanner.js